var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAlert48Filled = function SvgIconAlert48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m38.979 30.35-10.39-18a5.25 5.25 0 0 0-4.59-2.65 5.25 5.25 0 0 0-4.59 2.64l-10.4 18a5.3 5.3 0 0 0 4.59 7.95h20.75a5.3 5.3 0 0 0 4.59-7.95l.04.01Zm-13.28 1.19h-3.35v-3h3.4l-.05 3Zm0-5h-3.35v-7.6h3.4l-.05 7.6Z",
    fill: "current"
  })));
};
export default SvgIconAlert48Filled;